import {curveBasis} from '@visx/curve';
import {LinePath} from '@visx/shape';
import cx from 'classnames';
import {Component} from 'react';
import {Popup} from 'semantic-ui-react';

import './GraphLink.less';

export default class GraphLink extends Component {
  static defaultProps = {
    lineRadius: 5,
    offsetOutX: 25,
    offsetOutY: 40,
    offsetInY: 25,
  };

  render() {
    const {aggregated, from, to, highlighted, isDragging,
      offsetOutX, offsetOutY, offsetInY, onClose, canClose} = this.props;

    const closeOnHorizontal = Math.abs(to.x - from.x) > Math.abs(to.y - from.y);
    const btnX = closeOnHorizontal ? 0.5 * (from.x + to.x - offsetOutX) : from.x - offsetOutX;
    const btnY = closeOnHorizontal ? to.y - offsetInY : 0.5 * (from.y + to.y - offsetInY);
    return (
      <g
        className={cx('graph-link', {highlighted, dragging: isDragging, aggregated})}
      >
        <LinePath
          className='link'
          data={[
            {x: from.x, y: from.y},
            {x: from.x - offsetOutX, y: from.y},
            {x: from.x - offsetOutX, y: from.y + offsetOutY},
            {x: to.x, y: to.y - offsetInY},
            {x: to.x, y: to.y},
          ]}
          x={({x}) => x}
          y={({y}) => y}
          curve={curveBasis}
        />
        {canClose &&
          <Popup
            trigger={
              <g
                className='close-button'
                onClick={onClose}
              >
                <circle
                  cx={btnX}
                  cy={btnY}
                  r={5}
                />
                <path
                  d={`M${btnX - 2},${btnY - 2}l4,4M${btnX + 2},${btnY - 2}l-4,4`}
                />
              </g>
            }
            content='Delete'
            offset={[-14, 0]}
          />
        }
      </g>
    );
  }
}
